<template>
  <b-nav class="nav-toggled dropSpace">
    
    <b-nav-item-dropdown id="user-dropdown" class="toggled" :text="user.FullName" right>
      <b-dropdown-item class="drop-item"
        v-b-modal.modalPassword
        v-if="user.Permissions.alterarsenha.allowed && user.Permissions.alterarsenha.permission"
        ><img
          class="dropItem"
          src="@/assets/alterarsenha.png"
          :alt="$t('alterar-senha')"
        />{{ $t('alterar-senha-de-acesso') }}</b-dropdown-item
      >
      <b-dropdown-item class="drop-item"
        to="/admin"
        v-if="user.Permissions.cadastrarusuario.allowed && user.Permissions.cadastrarusuario.permission"
        ><img
          class="dropItem"
          src="@/assets/cadastrarusuarios.png"
          :alt="$t('gestao-de-usuarios')"
        />{{ $t('gestao-de-usuarios') }}</b-dropdown-item
      >
      <b-dropdown-item class="drop-item"
        to="/adminProfile"
        v-if="user.Permissions.cadastrarperfis.allowed && user.Permissions.cadastrarperfis.permission"
        ><img
          class="dropItem"
          src="@/assets/Login.png"
          :alt="$t('gestao-de-perfis')"
        />{{ $t('gestao-de-perfis') }}</b-dropdown-item
      >
      <b-dropdown-item class="drop-item" v-b-modal.modalWorkShift 
        v-if="user.Permissions.configurarturno.allowed && user.Permissions.configurarturno.permission" 
        ><img
          class="dropItem"
          src="@/assets/configuracoes2.png"
          :alt="$t('configurar-turnos')"
        />{{ user.Permissions.configurarturno.permission }}</b-dropdown-item
      >

      <b-dropdown-item class="drop-item"
        to="/changehistorylogs"
        v-if="user.Permissions.historicoalteracoes && user.Permissions.historicoalteracoes.allowed && user.Permissions.historicoalteracoes.permission"
        ><img
          class="dropItem"
          src="@/assets/historico_alteracoes.png"
          :alt="$t('historico-alteracoes')"
        />{{ $t('historico-alteracoes') }}</b-dropdown-item
      >

      <b-dropdown-item
        class="drop-item"
        :to="`/analytics/registrationproduct`"
        v-if="user.Permissions.analisecadastroproduto.allowed && user.Permissions.analisecadastroproduto.permission"
      >
        <img
          class="dropItem"
          src="@/assets/storage.png"
          :alt="$t('cadastro-de-produtos')"
        />
        {{ user.Permissions.analisecadastroproduto.permission }}
      </b-dropdown-item>
      <b-dropdown-item
        class="drop-item"
        :to="`/analytics/registrationprocess`"
        v-if="user.Permissions.analisecadastroprocesso.allowed && user.Permissions.analisecadastroprocesso.permission"
      >
        <img
          class="dropItem"
          src="@/assets/industry.png"
          :alt="$t('cadastro-de-processos')"
        />
        {{ user.Permissions.analisecadastroprocesso.permission }}
      </b-dropdown-item>
      <b-dropdown-item
        class="drop-item"
        :to="`/analytics/registrationequipment`"
        v-if="user.Permissions.analisecadastroequipamento.allowed && user.Permissions.analisecadastroequipamento.permission"
      >
        <img
          class="dropItem"
          src="@/assets/calcularIndicadores.png"
          :alt="$t('cadastro-de-equipamentos')"
        />
        {{ user.Permissions.analisecadastroequipamento.permission }}
      </b-dropdown-item>
       
      <b-dropdown-item class="drop-item" v-b-modal.modalIdleTime
        v-if="user.Permissions.configurarociosidade.allowed && user.Permissions.configurarociosidade.permission"
        ><img
          class="dropItem"
          src="@/assets/replannedOrange.png"
          :alt="$t('configurar-tempo-de-ociosidade')"
      
        />{{user.Permissions.configurarociosidade.permission}}</b-dropdown-item
      >

      <b-dropdown-item id="logout" class="drop-item" href="#" @click.prevent="logout"
        ><img
          class="dropItem"
          src="@/assets/sair.png"
          :alt="$t('sair')"
        />{{ $t('sair') }}</b-dropdown-item
      >
    </b-nav-item-dropdown>
    <template>
      <img class="Item toToggle2" src="@/assets/Login.png" :alt="$t('user')" />
    </template>

    <b-modal id="modalIdleTime" hide-footer :title="$t('configurar-ociosidade')">
      <idleTime></idleTime>
    </b-modal>

    <b-modal id="modalWorkShift" hide-footer size="lg" :title="$t('configurar-turno-de-trabalho')">
      <workshift></workshift>
    </b-modal>

    <b-modal id="modalPassword" hide-footer :title="$t('alteracao-de-senha')">
      <changePassword></changePassword>
    </b-modal>
  </b-nav>
</template>

<script>
import axios from "axios";
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import idleTime from "../idleTime/idleTime";
import changePassword from "../password/changePassword.vue";
import workshift from "../workshift/workshift.vue"
import { clearAllData } from '../../global';

export default {
  name: "UserDropdown",
  components: { changePassword, workshift, idleTime },
  data: () => {
    return {
      user: null,
    }
  },
  methods: {
    async deleteKeyInDatabase(){
      try {
        let userName = this.user.UserName;
        let obj = {};
        obj.userName = window.btoa(JSON.stringify(userName));
        obj.unitId = parseInt(this.user.UnitId);
        obj.system = this.user.role == "GDI" ? "G": "P";
        const url = `${urlMainAPI}/disconnectuser`;
        await axios
          .post(url, obj)
          .then(res => {
            defaultSuccess(res.data);
            clearAllData();
            this.$store.commit("setUser", null);
            this.$store.commit("setToken", null);
            this.$store.commit("setXML", null);
            this.$store.commit("setSystem", null);
            this.$router.push({ name: "auth" });
          })
          .catch(console.log);
      } catch (error) {
        showError(this.$t('problema-na-conexao-com-a-api'))
      }
    },
    logout() {
      this.deleteKeyInDatabase();
    }
  },
  created () {
    this.user = this.$store.state.user;
  }
};
</script>

<style scoped>

.dropSpace {
  min-width: 165px;
  flex-wrap: nowrap;
}

img.Item {
  max-height: 37px;
  max-width: 37px;
  border-radius: 5px;
}

img.dropItem {
  max-height: 25px;
  max-width: 25px;
  border-radius: 5px;
  margin-right: 10px;
}

.txt {
  color: white;
  padding: 10px 20px;
}

.ilink {
  margin-right: 10px;
}

</style>
